<template>
  <div>
    <div class="admin_title" style="position: relative">考题大分类管理 <a href="javascript:;" @click="goBack()" class="class_back_top">返回</a></div>
    <!--右侧内容-->
    <div class="gj_top_class">
      <!--<input name="" type="button" class="btn_s_gj" /><input name="" type="text" class="put_gj"/>
      <select name="">
        <option>试卷管理</option>
      </select>-->
      <a href="javascript:;" @click="create_s('')">新增小分类</a>
      <a href="javascript:;" @click="edit(null, null)">新增大分类</a>
    </div>
    <div class="add_shijuan_con mmHeight">
      <table id="customers">
        <tr>
          <th width="50%">大分类名称</th>
          <th width="15%">排序</th>
          <th width="35%">操作</th>
        </tr>
        <tr v-for="item in list" :key="item.id">
          <td>{{item.label}}</td>
          <td>暂无排序</td>
          <td>
            <a href="javascript:;" class="red_font_a" @click="del(item.id)">删除</a>
            <a href="javascript:;" class="red_font_a" @click="edit(item.id, item.label, item.value)">修改</a>
            <a href="javascript:;" class="red_font_a" @click="relate_s(item.value, item.label)">关联小分类</a>
          </td>
        </tr>
      </table>
    </div>
    <!--/右侧内容-->
    <!--/右侧内容-->
    <!--添加大类弹出-->
    <div class="tan add_b_menu" style="display:none;">
      <div class="add_con">
        <dl>
          <dt><input name="" type="text"  v-model="name" placeholder="请输入大分类名称"/></dt>
          <dd><input name="" type="button" value="取消" @click="$utils.fadeOut('.add_b_menu')"/>　　<input name=""
                                                                                                       type="button"
                                                                                                       value="确定"
                                                                                                       class="red_color"
                                                                                                       @click="submitClassification(name, name_sort, value)"/>
          </dd>
        </dl>
      </div>
    </div>
    <!--/添加大类弹出-->
  </div>
</template>
<script>

  export default {
    components: {},
    data () {
      return {
        filter: {
          type: 'examLargeType'
        },
        list: [],

        name: '',
        value: '',
        name_sort: '0',
        classification: {},
        prefix: this.$route.meta.prefix || ''
      }
    },
    created () {
      this.getClassifications(this.filter)
    },
    mounted () {
      this.$nextTick(() => {})
    },
    computed: {},
    methods: {
      getClassifications (filter) {
        this.$api.post(this.$global.examApiPath, '/dict/get', filter, r => {
          this.list = r.data
        })
      },
      // 编辑大分类
      edit(id, name, value) {
        if (name == null) {
          this.$utils.fadeIn('.add_b_menu')
          this.name = ''
          this.value = ''
        } else if (name != null) {
          this.$utils.fadeIn('.add_b_menu')
          this.name = name
          this.value = value
        }
        this.classification = {
          type: "examLargeType",
          id: id
        }
      },
      create_s () {
        this.$router.push({path: this.prefix + '/org/examQClassification_s/'+ this.$utils.URLencode(this.$route.params.path) + '/' + this.$route.params.id})
      },
      relate_s (value, label) {
        this.$router.push({path: this.prefix + '/org/examQClassification_relate/'+ this.$utils.URLencode(this.$route.params.path) + '/' + this.$route.params.id + '/' + value + '/' + label})
      },
      submitClassification(name, sort, value) {
        if (name && name != '') {
          this.classification.label = name
          this.classification.sort = sort
          this.classification.value = value
          this.$api.post(this.$global.examApiPath, '/dict/save', this.classification, r => {
            this.classification = {}
            this.$utils.fadeOut('.add_b_menu')
            this.getClassifications(this.filter)
          })
        }
      },
      del (id) {
        this.$api.post(this.$global.examApiPath, '/dict/delete', {id: id}, r => {
          this.getClassifications(this.filter)
        })
      },
      goBack () {
        let path = this.$route.params.path
        this.$router.push({path: path})
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/examination_question/classification_f.vue